import React from "react";
import {Card, Input, List, Skeleton} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {HeaderText} from "../profileStyles";
import "./UserInfoCard.css";

export const UserInfoCard = ({username, email}) => {
    const {t} = useTranslation(["profilePage"]);

    const userInfo = [
        {title: t("fields.username", {ns: "common"}), value: username},
        {title: "E-mail", value: email}
    ];

    return (
        <Card
            title={
                <h4>
                    <UserOutlined />
                    <HeaderText>{t("profilePage.userInfoHeader", {ns: "profilePage"})}</HeaderText>
                </h4>
            }
            style={{minHeight: "100%"}}
        >
            <List
                dataSource={userInfo}
                renderItem={row => (
                    <List.Item style={styles.listItem}>
                        <Skeleton loading={false} active>
                            <List.Item.Meta description={row.title} style={styles.listItemMeta} />
                            {/* <div
                                data-testid="userInfo"
                                data-testvalue={row.title}
                                style={styles.listItemValue}
                            >
                                {row.value}
                            </div> */}
                            <Input value={row.value} disabled className="user-info-input" />
                        </Skeleton>
                    </List.Item>
                )}
                style={styles.list}
            />
        </Card>
    );
};

const styles = {
    list: {
        backgroundColor: "#fff",
        borderRadius: "4px"
    },
    listItem: {
        padding: "12px 0",
        borderBottom: "1px solid #f0f0f0"
    },
    listItemMeta: {
        padding: "10px 20px",
        minWidth: "150px",
        fontWeight: "500",
        color: "#666"
    },
    listItemValue: {
        padding: "10px 20px",
        flex: 1,
        fontWeight: "400",
        color: "#333"
    }
};
